export const queryKeys = {
  products: {
    categories: ["getCategoriesDataQuery"],
  },
  stories: {
    groups: ["stories", "groups"] as const,
    items: (storyGroupId: string | null) =>
      ["stories", "items", storyGroupId] as const,
  },
  accommodations: {
    /** Capacity is part of the key — it changes the totals, not just the filtering */
    pdpPrices: (
      id: string,
      checkIn: string,
      checkOut: string,
      capacity: number,
    ) =>
      [
        "accommodations",
        id,
        "prices",
        "pdp",
        checkIn,
        checkOut,
        capacity,
      ] as const,
    pdpPriceCalendar: (
      id: string,
      from: string,
      to: string,
      capacity: number,
    ) =>
      ["accommodations", id, "prices", "calendar", from, to, capacity] as const,
  },
  references: {
    cities: ["references", "cities"],
    provinces: ["references", "provinces"],
    origins: ["references", "origins"],
    accommodationTypes: ["references", "types"],
    amenities: ["references", "amenities"],
  },
  health: {
    ready: ["health", "ready"] as const,
    monitor: ["health", "monitor"] as const,
  },
  search: {
    filters: ["search", "filters"],
    cityAutocomplete: (query: string) =>
      ["search", "cities", "autocomplete", query] as const,
    weather: (city: string, checkIn: string, checkOut: string) =>
      ["search", "weather", city, checkIn, checkOut] as const,
  },
};
